import type { ChangeEvent } from 'react';
import { twMerge } from 'tailwind-merge';

interface UploadButtonProps {
  icon?: React.ReactNode;
  label?: string;
  name: string;
  fileTypesAccepted: string;
  multipleFiles?: boolean;
  customStyle?: string;
  disabled?: boolean;
  changeHandler: (e: ChangeEvent<HTMLInputElement>) => Promise<void>;
}
function UploadButton({ icon, label, name, fileTypesAccepted, multipleFiles, customStyle, disabled, changeHandler }: UploadButtonProps) {
  return (
    <div className={twMerge(['relative flex items-center', disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer', customStyle])}>
      <input
        type='file'
        name={name}
        className={twMerge(['absolute w-full h-full rounded-md opacity-0', disabled ? 'cursor-not-allowed' : 'cursor-pointer'])}
        accept={fileTypesAccepted}
        multiple={multipleFiles}
        disabled={disabled}
        onChange={changeHandler}
      />
      <div className='px-4 py-2 w-full h-full flex gap-2'>
        {icon} {label}
      </div>
    </div>
  );
}
export default UploadButton;
